
import {FETCH_SCOPEACTIVITY_REQUEST, FETCH_SCOPEACTIVITY_SUCCES, FETCH_SCOPEACTIVITY_ERROR} from '../constants/ScopeActivity'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function scope_activity(state = initialState, action) {
  switch (action.type) {
      case FETCH_SCOPEACTIVITY_REQUEST:
        return {...state, isLoading: true};
      case FETCH_SCOPEACTIVITY_SUCCES:
        return {...state, list: action.payload.results, isLoading: false};
      case FETCH_SCOPEACTIVITY_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scope_activity.js